import {NgModule, ModuleWithProviders, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

// services
//import {AuthGuard} from './auth.guard.ts.old';

// components
import { WccrBoxComponent } from './components/wccr-box/wccr-box.component';
import { WccrBoxGroupComponent } from './components/wccr-box-group/wccr-box-group.component';
import { ShockMtmValueComponent } from './components/shock-mtm-value/shock-mtm-value.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HorizonTimeRangeComponent } from './components/horizon-time-range/horizon-time-range.component';
import { AampItemQuotaComponent } from './components/aamp-item-quota/aamp-item-quota.component';
import { DerivativeHoldingsChartComponent } from './components/derivative-holdings-chart/derivative-holdings-chart.component';
import {NgChartsModule} from 'ng2-charts';
import { EntityCcrExeChartComponent } from './components/entity-ccr-exe-chart/entity-ccr-exe-chart.component';
import { CounterPartyCcrEceChartComponent } from './components/counter-party-ccr-ece-chart/counter-party-ccr-ece-chart.component';
import { DerivativesVsCollateralChartComponent } from './components/derivatives-vs-collateral-chart/derivatives-vs-collateral-chart.component';
import { SmallCcrChartComponent } from './components/small-ccr-chart/small-ccr-chart.component';
import { GridInputControlComponent } from './components/grid-input-control/grid-input-control.component';
import {CoreModule} from '../../core/core.module';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        NgbModule,
        NgChartsModule,
        FormsModule,
        CoreModule,
        ReactiveFormsModule,
        AgGridModule
    ],
    declarations: [WccrBoxComponent, WccrBoxGroupComponent, ShockMtmValueComponent, HorizonTimeRangeComponent, AampItemQuotaComponent,
        DerivativeHoldingsChartComponent, EntityCcrExeChartComponent, CounterPartyCcrEceChartComponent,
        DerivativesVsCollateralChartComponent, SmallCcrChartComponent, GridInputControlComponent],
    exports: [WccrBoxComponent, WccrBoxGroupComponent, ShockMtmValueComponent, HorizonTimeRangeComponent, AampItemQuotaComponent,
        DerivativeHoldingsChartComponent, EntityCcrExeChartComponent, CounterPartyCcrEceChartComponent,
        DerivativesVsCollateralChartComponent, SmallCcrChartComponent, GridInputControlComponent, FormsModule],

        schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule
        };
    }
}